<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/191JHYI/tc-custom/9780374717094.jpg?1722313039063" alt="This image is the cover for the book Secret Life"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Secret Life
      </h1>
      <p class="bookDescription body article font2">
        <p><b>Award-winning essayist and novelist Andrew O’Hagan presents a trio of reports exploring the idea of identity on the Internet—true, false, and in between—where your virtual self takes on a life of its own outside of reality.</b><br/><b><br/>A <i>Publishers Weekly </i>Best Book of the Year </b>• <b>One of </b><b><i>Publishers Weekly</i></b><b>'s Top 10 Book of </b><b>Essays and Literary Criticism</b> • <b>One of <i>Chicago Reader</i></b><b>'s Books We Can’t Wait to Read</b><br/><br/><i>The Secret Life</i> issues three bulletins from the porous border between cyberspace and IRL.<br/><br/>“Ghosting” introduces us to the beguiling and divisive Wikileaks founder Julian Assange, whose autobiography O’Hagan agrees to ghostwrite with unforeseen—and unforgettable—consequences. “The Invention of Ronnie Pinn” finds him using the actual identity of a deceased young man to construct an entirely new one in cyberspace, leading him on a journey deep into the Web’s darkest realms. And “The Satoshi Affair” chronicles the strange case of Craig Wright, the Australian Web developer who may or may not be the mysterious inventor of Bitcoin, Satoshi Nakamoto—and who may or may not be willing, or even able, to reveal the truth.<br/><br/>These fascinating pieces take us to the weirder fringes of life in a digital world while also casting light on our shared predicaments. What does it mean when your very sense of self becomes, to borrow a term from the tech world, “disrupted”? <i>The Secret Life</i> shows us that it might take a novelist, an inventor of selves, armed with the tools of a trenchant reporter, to find an answer.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Andrew O'Hagan
      </h2>
      
      <p class="authorDescription body article"><B>Andrew O’Hagan</B> is one of Britain’s most exciting and serious contemporary writers. He has been nominated for the Man Booker Prize three times, was voted one of <I>Granta</I>’s 2003 Best of Young British Novelists, and received the Los Angeles Times Book Prize and the E. M. Forster Award from the American Academy of Arts and Letters. He is the author of <I>Our Fathers</I>, <I>Be Near Me</I>, and <I>The Illuminations</I>, among other books. He lives in London.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Farrar, Straus and Giroux
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?01ab05f8